/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import Slider from '@farbenmeer/react-spring-slider';
import clsx from 'clsx';
import useStore from 'state/state';
import { bool } from 'prop-types';

import OnboardingS1 from 'assets/images/onboarding/onboarding-s1.svg';
import OnboardingS2 from 'assets/images/onboarding/onboarding-s2.svg';
import OnboardingS3 from 'assets/images/onboarding/onboarding-s3.svg';
import OnboardingS4 from 'assets/images/onboarding/onboarding-s4.svg';
import ArrowLeft from 'assets/images/onboarding/arrow-left.svg';
import ArrowRight from 'assets/images/onboarding/arrow-right.svg';
import styles from './OnboardingSlideshow.module.scss';

const OnboardingSlideshow = ({ intro, loadingComplete }) => {
  const appData = useStore((state) => state.appData);
  const [activeIndex, setActiveIndex] = useState(0);
  const [paginIndex, setPaginIndex] = useState(0);
  const [prevActive, setPrevActive] = useState(false);
  const [nextActive, setNextActive] = useState(false);
  const [autoPlay, setAutoPlay] = useState(false);
  const [leftAlign, setLeftAlign] = useState(false);
  const timeOut = useRef(null);
  const autoPlayRef = useRef();
  // const [paginIndex, setPaginIndex] = useState(null);
  const slidesData = appData.mainData.onboarding.slides;

  let autoPlayIndex = activeIndex;
  autoPlayRef.current = autoPlay;

  const onSlideChange = (event) => {
    setPaginIndex(event);
    setActiveIndex(event);
  };
  const onSlideClick = () => {
    setAutoPlay(false);
    autoPlayRef.current = false;
  };
  const onNext = () => {
    const newIndex = activeIndex + 1;
    setPaginIndex(newIndex);
    setActiveIndex(newIndex);
    setAutoPlay(false);
    autoPlayRef.current = false;
  };

  const onPrev = () => {
    const newIndex = activeIndex - 1;
    setPaginIndex(newIndex);
    setActiveIndex(newIndex);
    setAutoPlay(false);
    autoPlayRef.current = false;
  };

  // const setSlideCustomIndex = () => activeIndex;
  const onPaginClick = (event) => {
    setActiveIndex(parseInt(event.currentTarget.dataset.index, 10));
    setAutoPlay(false);
    autoPlayRef.current = false;
  };

  const slides = [
    {
      key: 'slide0',
      dotKey: 'dot0',
      text: slidesData[0].descriptionText,
      img: <OnboardingS1 />,
    },
    {
      key: 'slide1',
      dotKey: 'dot1',
      text: slidesData[1].descriptionText,

      img: <OnboardingS2 />,
    },
    {
      key: 'slide2',
      dotKey: 'dot2',
      text: slidesData[2].descriptionText,

      img: <OnboardingS3 />,
    },
    {
      key: 'slide3',
      dotKey: 'dot3',
      text: slidesData[3].descriptionText,
      img: <OnboardingS4 />,
    },
  ];

  const runAutoPlay = () => {
    if (!autoPlayRef.current) {
      return;
    }
    let newIndex = autoPlayIndex + 1;
    // console.log(newIndex, activeIndex);
    if (newIndex === slides.length) {
      // console.log('s');
      newIndex = 0;
    }

    setActiveIndex(newIndex);
    setPaginIndex(newIndex);
    autoPlayIndex = newIndex;

    if (autoPlayRef.current) {
      timeOut.current = setTimeout(() => {
        clearTimeout(timeOut.current);
        runAutoPlay();
      }, 3000);
    }
  };

  useEffect(() => {
    const lang = document.querySelector('meta[name="geo.region"]');
    if (lang) {
      if (lang.content.toLowerCase() === 'jp') {
        setLeftAlign(true);
      }
    }
  }, []);

  useEffect(() => {
    if (activeIndex === 0) {
      setPrevActive(false);
    } else {
      setPrevActive(true);
    }

    if (activeIndex === slides.length - 1) {
      setNextActive(false);
    } else {
      setNextActive(true);
    }

    setActiveIndex(activeIndex);
  }, [activeIndex, prevActive, nextActive, slides.length]);

  useEffect(() => {
    if (autoPlay) {
      timeOut.current = setTimeout(() => {
        clearTimeout(timeOut.current);
        runAutoPlay();
      }, 3000);
    }
    autoPlayRef.current = autoPlay;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoPlay]);

  useEffect(() => {
    if (!intro || (intro && loadingComplete)) {
      setAutoPlay(true);
      return function cleanup() {
        clearTimeout(timeOut.current);
        timeOut.current = null;
      };
    }
  }, [intro, loadingComplete]);

  return (
    <div className={styles.wrapper}>
      {activeIndex !== null && (
        <>
          <Slider
            activeIndex={activeIndex}
            onSlideChange={onSlideChange}
            className={styles.slider}
          >
            {slides.map(({ text, img, key }) => (
              <button
                type="button"
                key={key}
                className={styles.slide}
                onClick={onSlideClick}
              >
                <div className={styles.img}>{img}</div>
                <span
                  className={clsx(styles.description, {
                    [styles.intro]: intro,
                    [styles.leftAlign]: leftAlign,
                  })}
                >
                  {text}
                </span>
              </button>
            ))}
          </Slider>
          <div
            className={clsx(styles.pagination, {
              [styles.hidden]: intro && !loadingComplete,
            })}
          >
            <button
              onClick={onPrev}
              type="button"
              alt="prev slide"
              className={clsx(styles.leftArrow, {
                [styles.inactive]: !prevActive,
              })}
            >
              <ArrowLeft />
            </button>
            <div className={styles.dots}>
              {slides.map(({ dotKey }, index) => (
                <button
                  key={dotKey}
                  type="button"
                  alt="pagination button"
                  data-index={index}
                  onClick={onPaginClick}
                  className={clsx(styles.dot, {
                    [styles.isActive]: index === paginIndex,
                    [styles.hidden]: intro && !loadingComplete,
                  })}
                />
              ))}
            </div>
            <button
              type="button"
              alt="next sldie"
              onClick={onNext}
              className={clsx(styles.rightArrow, {
                [styles.inactive]: !nextActive,
                [styles.hidden]: intro && !loadingComplete,
              })}
            >
              <ArrowRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

OnboardingSlideshow.propTypes = {
  intro: bool.isRequired,
  loadingComplete: bool.isRequired,
};

export default OnboardingSlideshow;
